/***
 * Shop Javascript
 * 
 * 
 ***/	


/**
 * Extending jQuey validator: Remote-VAT
 */
var pt_vat_defaultMessage = '';
 $.validator.addMethod(
		"remoteVATCheck",
		function( value, element, param ) {
			
			if ( this.optional(element) ) {
				return "dependency-mismatch";
			}

			var previous = this.previousValue(element);
			if (!this.settings.messages[element.name] ) {
				this.settings.messages[element.name] = {};
			}
			previous.originalMessage = this.settings.messages[element.name].remote;
			this.settings.messages[element.name].remote = previous.message;

			param = typeof param === "string" && {url:param} || param;

			if ( previous.old === value ) {
				this.settings.messages['vatnr'] = previous.message;
				return previous.valid;
			}
			previous.old = value;
			
			var validator = this;
			this.startRequest(element);
			var data = {};
			data[element.name] = value;
			$.ajax($.extend(true, {
				url: param,
				mode: "abort",
				port: "validate" + element.name,
				dataType: "json",
				data: data,
				success: function( response ) {
					validator.settings.messages[element.name].remote = previous.originalMessage;
					// <these lines modified>
					// We want to BLOCK invalid VAT Nr from posting, we check the result
					var valid = response.vatNrCorrect; 
					// </modified>
					// <these lines modified>
					// Show the result before finishing the form handling - otherwise form may be submitted before capturing data. FS#7167
					ptShowVatCheckerResult(response); 
					// </modified>
					if ( valid ) {
						var submitted = validator.formSubmitted;
						validator.prepareElement(element);
						validator.formSubmitted = submitted;
						validator.successList.push(element);
						delete validator.invalid[element.name];
						validator.showErrors();
					} else {
						var errors = {};
						var message = response.message || 'Kyselak';//validator.defaultMessage( element, "remote" );
						pt_vat_defaultMessage = message;
						errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
						validator.invalid[element.name] = true;
						validator.showErrors(errors);
					}
					previous.valid = valid;
					validator.stopRequest(element, valid);
				},
				error: function (jqXHR, textStatus, errorThrown) {
					
					ptClientErrorLog({caller: 'ptshop.js:remoteVATCheck', textStatus: textStatus, errorThrown: errorThrown });
					
					// simplified check FS#8186. See also CheckVatNr.
					var billingCountry = ptGetBillingCountry();
					var applyUst = ('AT' == billingCountry);
					
					ptShowVatCheckerResult({
							vatNrCorrect: 1,
							applyUst : applyUst,
							message : 'VAT Prüfung war nicht möglich. ACHTUNG: manuelle Prüfung vor Rechnungsstellung notwendig! Fehler: ' + errorThrown + '. Text Status: ' + textStatus,
							uid2validate : '',
							AjaxErrorState: {
								textStatus: textStatus, 
								errorThrown: errorThrown,
								billingCountry: billingCountry
							}
					});
					
					// FS#8186
					validator.pendingRequest--; // THIS IS ESSENTIAL -> then the button can be at least clicked again.			
					var valid = true;

					if ( valid ) {
						var submitted = validator.formSubmitted;
						validator.prepareElement(element);
						validator.formSubmitted = submitted;
						validator.successList.push(element);
						delete validator.invalid[element.name];
						validator.showErrors();
					} else {
						var errors = {};
						var message = response || validator.defaultMessage( element, "remote" );
						errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
						validator.invalid[element.name] = true;
						validator.showErrors(errors);
					}
					previous.valid = valid;
					validator.stopRequest(element, valid);
				}
			}, param));
			return "pending";
		}
);
 
/**
 * Check whether a country is an EU Country
 * Requires ptShop
 */
function ptShopIsTaxableEuCountry(country) {
	if (undefined === ptShop)
		throw new Error('ptShopIsTaxableEuCountry: ptShop is undefined');

	// EU countries are part of the Shop parameters
	return (undefined !== ptShop.vatRatePerCountry[country]);
 }

 /**
  * Show/store the CheckVatNr result.
  * Does not trigger further action.
  * @param response
  */
function ptShowVatCheckerResult( response ) {
	if (!response.addressCheck) {		
		response.addressCheck = '';
	}
	
	var vatnrmessage = jQuery('#vatnr-error');
	jQuery('input[name=vatNrCorrect]').val(JSON.stringify(response.vatNrCorrect));
	jQuery('input[name=vatApplyUst]').val(JSON.stringify(response.applyUst));
	jQuery('input[name=vatMessage]').val(response.message);
	jQuery('input[name=vatNrVerified]').val(response.uid2validate);
	// Store country and address, too
	jQuery('input[name=vatNrCheckResult]').val(JSON.stringify(response));
	
	if (('' !== response.vatNrCorrect) && (! response.vatNrCorrect)) {
		
		vatnrmessage.html(response.message);
		if ('error' == response.messageType)
			vatnrmessage.addClass('vatnrerror');
		else 
			vatnrmessage.removeClass('vatnrerror');
		vatnrmessage.fadeIn();
	} else {
		vatnrmessage.fadeOut();
	}
	jQuery.when(vatnrmessage).done(
		// fade-animation has to be complete. next step checks visibility and updates tax
		function() {		
			ptCheckToggleVatnrnotapplicable();
			ptVatRelevantChange_UpdateAmount();
		}
	);
}
/**
 * Don't reset the checkbox on the first call, it could be prechecked after cancel
 */
var ptShopCheckVatRequirementsFirstCall = true;

/**
 * Check if the VAT Number field must be required for this order form. 
 * This is called 
 * - on init 
 * - onchange of separatebillingaddress, address1_country, address2_country  
 */
function ptShopCountryChanged_CheckVatRequirements() {
	var adcountry = ptGetBillingCountry();

	// VAT NR is required. Depends on billing country being in EU.
	var vatNrIsRequired;
	// in CH vat is required but there is no automatic check!!
	var ajaxCheckEnabled;
	// in EU countries, "VATNR is not applicable for me" can be checked. 
	// in CH, it is required and it is not possible to say "not applicable for me" 
	var notApplicableAllowed;
	// is VAT applicable?
	var applyUst;
	// there are more VAT Options for IT: See FS#18550
	var showITRadios = false;
	$('input[name=vatoptionsSpecial]').rules('remove');
	$('.vatSpecialOnly').hide();
	$('.ITOnly, .ESOnly').hide();
	
	$('.vatInputBox').removeClass('special');
	
	if (!adcountry) {
		// No country selected yet. Seperatebillingaddress is "+ptShop_sepbill+". VAT is not required. Waiting that country will be entered.
		vatNrIsRequired = false;
		ajaxCheckEnabled = false;
		notApplicableAllowed = false;
		applyUst = false;
	} else {
		adcountry = adcountry.toUpperCase();
		
		// FS#19320 Länderspezifische VAT Bezeichnung
		// ATTENTION: you also need to change all other places with FS#19320: PtShop::getVATNrLabel()
		if(ptShop.language == 'en') {
			if(adcountry == 'CA') {
				$('.vatInputBox label').text('Business Number *');
			} else if (adcountry == 'GB') {
				$('.vatInputBox label').text('Company number *');
			} else {
				$('.vatInputBox label').text(pLang__('initvatnrlabel')+' *');
			}
		} else if (ptShop.language == 'fr' && adcountry == 'CA') {
			$('.vatInputBox label').text('Numéro d’entreprise *');
		} else {
			$('.vatInputBox label').text(pLang__('initvatnrlabel')+' *');
		}
		
		// LS&MG 15.12.2014: all EU, incl AT, require VAT Number and may have VAT
		vatNrIsRequired = ptShopIsTaxableEuCountry(adcountry);
		// FS#13894 VAT is required but not checked?
		if(ptShop.vatRequiredWithoutVatCheckCountries.indexOf(adcountry) != -1){
			vatNrIsRequired = true;
			ajaxCheckEnabled = false;
			notApplicableAllowed = false;
			applyUst = false; // CH does not pay VAT, FS#13894
			$('.vatInputBox').show();
		} else if (adcountry == "IT" || adcountry == "ES") {
			// special handling of IT & ES vatnr entry
			vatNrIsRequired = true;
			ajaxCheckEnabled = true;
			applyUst = true;
			showITRadios = true;
			notApplicableAllowed = false;
			
			$('input[name=vatoptionsSpecial]').rules("add", { required:true });
			$('.vatSpecialOnly').show();
			$('.'+adcountry+'Only').show();
			$('.vatInputBox').hide();
			
			$('input[value=vatoptions_have]').prop('checked', true);
			$('.vatInputBox').show().addClass('special');
			
			if($('input[name=vatoptionsSpecial]:checked').val() == "vatoptions_have" ) $('.vatInputBox').show().addClass('it');
			
			priceCalculatorUpdate();
			
			// to ensure updates within IT radios
			$('input[name=vatoptionsSpecial]').unbind('change');
			$('input[name=vatoptionsSpecial]').on('change', function(){

				if($('input[name=vatoptionsSpecial]:checked').val() == "vatoptions_have") {
					vatNrIsRequired = true;
					ajaxCheckEnabled = true;
					showITRadios = true;
					notApplicableAllowed = false;
					$('.vatInputBox').show().addClass('special');
					ptPrepareVatField(vatNrIsRequired, ajaxCheckEnabled, notApplicableAllowed, applyUst, adcountry, true);
					$('input[name=vatnrnotapplicable]').prop('checked', false);
					$('input[name=vatnr]').prop('disabled', false);
				} else {
					$('.vatInputBox').hide();
					vatNrIsRequired = true;
					ajaxCheckEnabled = false;
					notApplicableAllowed = true;
					ptPrepareVatField(vatNrIsRequired, ajaxCheckEnabled, notApplicableAllowed, applyUst, adcountry, true);
					$('input[name=vatnrnotapplicable]').prop('checked', true);
					$('input[name=vatnr]').prop('disabled', 'disabled');
				}
				$('input[name=vatnrnotapplicable]').trigger('change');
				priceCalculatorUpdate();
			});
			
		} else {
			ajaxCheckEnabled = true;
			notApplicableAllowed = true;
			applyUst = vatNrIsRequired; // until the VAT is revalidated: we assume you have to pay VAT
			
			if(vatNrIsRequired) {
				$('.vatInputBox').show();
			} else {
				$('.vatInputBox').hide();
			}
		}
	}
	
	ptPrepareVatField(vatNrIsRequired, ajaxCheckEnabled, notApplicableAllowed, applyUst, adcountry, false);
	
	// The vatnrnotapplicable checkbox depends on country and amount of users. it may be hidden or visible now
	ptCheckToggleVatnrnotapplicable();
	// The #vatnrnotapplicable-vatmsg depends on ptCheckToggleVatnrnotapplicable() and country, check if it should be visible
	ptCheckVatnrnotapplicableVatmsg();
	ptShopCheckVatRequirementsFirstCall = false;
}


function ptPrepareVatField(vatNrIsRequired, ajaxCheckEnabled, notApplicableAllowed, applyUst, adcountry, vatoptionsSpecial) {
	var input_vatnr = $('input[name=vatnr]');
	var input_vatnr_row = input_vatnr.parents('.form-row');

	input_vatnr.data("vatnr-isRequired", vatNrIsRequired);
	input_vatnr.data("vatnr-ajaxCheck", ajaxCheckEnabled);
	input_vatnr.data("vatnr-notApplicableAllowed", notApplicableAllowed);
	input_vatnr.data("vatnr-vatoptionsSpecial", vatoptionsSpecial);
	
	// reset the VatNrNotApplicable check and view - hide it. Has to be done before re-validation of VAT, as VAT won't be validated if not applicable.
	if(!ptShopCheckVatRequirementsFirstCall)
		$('input[name=vatnrnotapplicable]').prop('checked', false);
	$('.vatnrnotapplicable').hide();
	
	if (vatNrIsRequired) { 
		input_vatnr.removeData("previousValue"); //clear cache when changing
		input_vatnr_row.show();
		ptShowVatCheckerResult({
			vatNrCorrect: '',
			applyUst : applyUst,
			message : ajaxCheckEnabled ? '' : '(shop will not check UID for country "' + adcountry + '")',
			uid2validate : ''
		});
		ptRevalidateVat(); // re-validate VAT. That will trigger ptVatRelevantChange_UpdateAmount() update, too
	} else {
		input_vatnr_row.hide();		
		input_vatnr.val('');
		input_vatnr.valid(); //revalidate to clear any "error" state
			
		ptShowVatCheckerResult({
			vatNrCorrect: '',
			applyUst : false,
			message : '(no UID check required for country "' + adcountry + '")',
			uid2validate : ''
		});
		
		ptVatRelevantChange_UpdateAmount();
	}
}

/**
 * Revalidate VAT NR when address fields change or when vatnrnotapplicable is toggled.
 * force: force a recheck (used when vatnrnotapplicable is checked/unchecked)
 */
function ptRevalidateVat(force) {
	var input_vatnr = $('input[name=vatnr]');
	if (input_vatnr.data("vatnr-isRequired")) {
		// VAT is required. 
		var vatnrnotapplicable_checked = jQuery('input[name=vatnrnotapplicable]').is(":checked");
		
		// if vatnrnotapplicable is set, then the field is disabled
		if (vatnrnotapplicable_checked) {
			input_vatnr.prop('disabled', true);
		} else {
			input_vatnr.prop('disabled', false);
		}
		
		// did the user change vatnrnotapplicable just now?
		if (force === true) {
			ptShowVatCheckerResult({
				vatNrCorrect: '',
				applyUst : true,
				message : vatnrnotapplicable_checked ?
					'(Customer does not have a VAT number (vatnrnotapplicable is set))' 
					: '',
				uid2validate : ''
			}); 
		}
		
		// Validate VAT nr...
		if ((force === true)  						// When forced (vatnrnotapplicable toggled)
			|| input_vatnr.val() 					// When it is set
			|| input_vatnr.hasClass('errorfield')	// When it is currently wrong
			) {
			 
			// first reset the previous query as a related field may have changed (address, name, ...), then revalidate
			input_vatnr.removeData("previousValue").valid();
		} 
	} else {
		// VAT is not required. 
		// ptShopCountryChanged_CheckVatRequirements already ensured that ptShowVatCheckerResult shows FALSE. Nothing to do.
		// form-submit and onblur will check and checking too early makes it red in a field of ivory white
	}	
}

/**
 * Check if vatnrnotapplicable should be shown
 * hasbeeninfocus: The user just left/changed the vat edit-field, from now on we can show this check. 
 */

function ptCheckToggleVatnrnotapplicable(hasbeeninfocus) {		
	var input_vatnr = $('input[name=vatnr]');
	var vatnrnotapplicable = $('.vatnrnotapplicable');
	var vatnrnotapplicablecheck = vatnrnotapplicable.children('[name=vatnrnotapplicable]');
	
	var userAmount = $('#useramount').val();
	
	if (true === hasbeeninfocus)
		input_vatnr.data('hasbeeninfocus', true);
	
	if (
			// first prerequisite: it must be required and allowed to override
			input_vatnr.data("vatnr-notApplicableAllowed") &&
			input_vatnr.data("vatnr-isRequired") &&
			!input_vatnr.data("vatnr-vatoptionsSpecial") &&
			(
				// when to show it ?
				
				// is it already checked? then keep showing it!
				vatnrnotapplicablecheck.is(":checked") || 
				
				// FS#20566 always show the checkbox for single user case 
				(userAmount == 1) || 
				// Multiple users / team: the user must have "tried" entering vatnr by clicking on the field and leaving it 
				// or checking vatnr and getting an error
				(
					input_vatnr.data('hasbeeninfocus') &&
					(
						!input_vatnr.val() // no vatnr was entered 
						|| 
						ptShop_formValidator.invalid.vatnr // or an VAT error is visible
					)
				)
			)
		)
	{
		vatnrnotapplicable.show();
		vatnrnotapplicable.parent().show();
	} else {
		vatnrnotapplicable.hide();
		vatnrnotapplicable.parent().hide();
	}
}


/**
 * show  #vatnrnotapplicable-vatmsg next to .vatnrnotapplicable checkbox if needed
 */
function ptCheckVatnrnotapplicableVatmsg() {
	// vatnrnotapplicable is checked, 
	// so show #vatnrnotapplicable-vatmsg to warn of added VAT tax,
	// FS#20566: but not in country=AT, where VAT is always added
	if (jQuery('input[name=vatnrnotapplicable]').prop('checked') 
		&& (priceCalc.billingCountry != 'AT')) {
		$('#vatnrnotapplicable-vatmsg').show();
	} else {
		$('#vatnrnotapplicable-vatmsg').hide();
	}
}

/**
 * Call this after any value changed that affects the VAT calculation
 * This determines whether VAT is applicable and re-calculates the price and shows the results
 */
function ptVatRelevantChange_UpdateAmount() {
	
	// abort if priceCalc not yet initialized. this happens at the beginning of the pageload regularly.
	if (priceCalc === undefined) {
		return;
	}
	
	var billingCountry = ptGetBillingCountry();
	
	var vatNrIsRequired = ptShopIsTaxableEuCountry(billingCountry);
	
	// when did the user say that he does not have a EU-VAT number and accepts paying EU-VAT?
	var vatnrnotapplicable = 
					jQuery( 'input[name=vatnrnotapplicable]' ).is(":checked")
					|| (billingCountry == 'IT' && !$('input[value=vatoptions_have]').prop('checked'));
	
	var doApplyVat =
		('AT' === billingCountry) || // In Austria: always VAT
		(vatNrIsRequired && vatnrnotapplicable);
		
	priceCalc.billingCountry = billingCountry;
	priceCalc.applyVat = doApplyVat;
	priceCalculatorUpdate();
}

/**
 * The Vat Nr was changed
 */
function ptVatNrChanged() {
	// if the vatnr was just blanked, the Validation framework will not revalidate if it is not required.
	var input_vatnr = $('input[name=vatnr]');
	if (!input_vatnr.val()
		&& ptShop_formValidator.invalid.vatnr) {
		jQuery('#vatnr-error').hide(); // override: the vatnrmessage must not be shown when empty
		input_vatnr.removeData("previousValue").valid();
	}
	ptCheckToggleVatnrnotapplicable(true);	
	ptVatRelevantChange_UpdateAmount();
}


/**
 * The currently selected billing country.
 * 
 * This also changeShop_sepbill which is used by valid-checkers below. 
 * As ptGetBillingCountry is called on the change-event of the separatebillingaddress, this ensures that the variable is right.
 * @returns 2-letter country code or "" if no country is selected 
 * (empty result can happen when switching separatebillingaddress or when selecting '' in the German-speaking combo with DACH on top)
 */
var ptShop_sepbill;
function ptGetBillingCountry() {
	ptShop_sepbill = (jQuery('input[name=separatebillingaddress]').prop("checked"));
	if (ptShop_sepbill) 
		return jQuery('select[name=address2_country]').val();
	else
		return jQuery('select[name=address1_country]').val();
}


/**
 * Country changed, trigger ptShopUpdateShopParameters, which will trigger ptShopCurrencyLoaded later.
 */
function ptShopCountryChanged_CheckUpdateShopParameters(r) {
	var billingCountry = ptGetBillingCountry();

	if ((ptShop === undefined) || (ptShop.country  === undefined) || (ptShop.country != billingCountry))
		ptShopUpdateShopParameters(billingCountry);
}


/**
 * Currency and Country loaded from server
 */
function ptShopCurrencyLoadedUpdateShop(e, _ptShop) { 
	
	// If NO COUNTRY was selected yet, set it accoring to the just retrieved ptShop.country
	var curCountry = jQuery('select[name=address1_country]').val();
	if ((!curCountry || curCountry.trim() == '') && ptShop.country) {
		if($("select[name=address1_country] option[value='"+ptShop.country+"']").length != 0) { // check if country exists in selct list
	   	$('select[name=address1_country]').val(ptShop.country);
			//$.uniform.update('select[name=address1_country]'); // tell uniform to show the last action
			$('select[name=address1_country]').trigger('change'); // trigger listeners to the country
		} else {
			ptClientErrorLog({caller: 'ptshop:ptShopCurrencyLoadedUpdateShop', errorThrown: ptShop.country+' does not exist in our accepted countries list! Country Select box was not updated!'});
		}
		
	}
	
	// store currency in hidden field
	$('input[name=currency]').val(ptShop.currency);
}
jQuery(document).on('ptShopCurrencyLoaded',  ptShopCurrencyLoadedUpdateShop );


/**
 * Take the form parameters and encode them into a URL
 * note; $('#orderform').serialize(); // returns too much 
 */
function ptParamsToUrl() {
	var myUrl = '';
	var jqselector = ''; 
	for (var i=0; i<ptShop.knownfields.length; i++) {
		if (jqselector != '')
			jqselector += ', ';
		jqselector += '#orderform [name='+ptShop.knownfields[i]+']';
	}
	// use jQuery's native serialization, which handles Radios
	var myUrl = $(jqselector).serialize();
	// now the URL contains empty values, too, remove them
	myUrl = myUrl.replace(/([a-zA-Z0-9\-_]+\=&)/g, '') // empty value within
		         .replace(/(&[a-zA-Z0-9\-_]+\=$)/g,''); // empty at the end
	myUrl = "https://www.portatour.com/shop/"+ptCommon.language+"?"+myUrl; // Always HTTPS - this is the SHOP
	$('#shopdebug_url').html('<br/><a href="'+myUrl+'">link to this page</a>');
}


/**
 * Update the "buy now" button. This is bound to the pricecalc update event.
 */
function ptShop_PriceCalcUpdated_ShowAmount() {
	// when the priceCalc is not ready yet, skip. this will be called on the first update by ptPriceCalculatorUpdated
	if (typeof(priceCalc) == 'undefined' )
		return;
	
	try {
		// Write out Tax values in backend fields
		$('input[name=invoiceamount]').val(priceCalc.invoiceamount);
		$('input[name=invoiceamountinclvat]').val(priceCalc.invoiceamountinclvat);
		$('input[name=vatrate]').val(priceCalc.vatrate);
		$('input[name=vatamount]').val(priceCalc.vatamount);
		
		var fmtArgs = {
			currency: ptShop.currency
		};
		$('#action-currency-subline').html(pLangF__('shopcurrencysub', fmtArgs));
		
		$('.hasOneTimeCost').hide();
		$('#orderSumRecurring').html(ptNumber.sprintNumber(priceCalc.licenseamount, 2, true));
		$('#orderSumOneTime').html(ptNumber.sprintNumber(priceCalc.servicesamount, 2, true));
		if(priceCalc.servicesamount > 0) $('.hasOneTimeCost').show();
		
		if (priceCalc.vatamount == 0) {
			$('#action-vat-subline').html('');
			$('#orderSumVatDetails').html('');
			$('.addVatInfoText').hide();
			$('#vatnrnotapplicable-vatmsg').html('');
			
		} else {
			var fmtArgs = {
				vatrate: ptNumber.sprintNumber(priceCalc.vatrate*100),
				vatamount: ptNumber.sprintNumber(priceCalc.vatamount, 2, 'plaintext')
			};
			var fmtArgs2 = {
				vatrate: ptNumber.sprintNumber(priceCalc.vatrate*100),
				totalincl: ptNumber.sprintNumber(priceCalc.invoiceamountinclvat, 2, true)
			};
			$('#action-vat-subline').html(pLangF__('shopvatsub', fmtArgs));
			$('#orderSumVatDetails').html(pLangF__('shopordersumvatsub', fmtArgs2));
			$('.addVatInfoText').show();
			$('#vatnrnotapplicable-vatmsg').html('→ ' + pLangF__('shopvatnotapplicable',fmtArgs	));
		}
				
	} catch (e) {
		ptClientErrorLog({caller: 'ptshop:ptShop_PriceCalcUpdated_ShowAmount', errorThrown: e});
		console.log("ptShop_PriceCalcUpdated_ShowAmount: " + e);
	}	
}

function changedIntegration (){
	
	
	$('#useramount').rules("remove", "min");
	var integration = $('input[name=integration]:checked').attr('id');
	
	if(integration != 'none' && integration != 'api') {
		$('#useramount').rules("add", { 
			required: true, 
			min: {
	      param: 10,
	      depends: function(element) {
	      	var integration = $('input[name=integration]:checked').val();
	        if( integration != 'none' && integration != 'api' ) {
	        	return true;
	        }
	    	}
    	}
	 	});	
	}
	
	if(integration == 'api') {
		$('#useramount').rules("add", { 
			required: true, 
			min: {
	      param: 2,
	      depends: function(element) {
	      	var integration = $('input[name=integration]:checked').val();
	        if( integration == 'api' ) {
	        	return true;
	        }
	    	}
    	}
	 	});	
	}
	
	if(integration == 'none') {
		$('#useramount').rules("add", { 
			required: true, 
			min: {
	      param: 1,
	      depends: function(element) {
	      	var integration = $('input[name=integration]:checked').val();
	        if( integration == 'none') {
	        	return true;
	        }
	    	}
    	}
	 	});	
	}
	
}

/** 
 * after first round of payment Type change set initialized to true
 * FS#9960: only preselect former selected value if it's not the initial ajax call
 * global variable b/c ptShop object is also reset on country change
 */
 var ptShopRepopulatePaymentTypeOptionsFirstCall = true;
 var uncheckLicenseTerms = false;
/**
 * When Country or amount is changed, call this to adapt the supported payment types
 */
function ptShopRepopulatePaymentTypeOptions() {
	uncheckLicenseTerms = true;

	// pall does restrict it
	if ($("input[name=pall]").val())
		return;

	// Remember the current selection if there is one
	var currentlySelected = jQuery('input[name=paymentType]:checked').length ? jQuery('input[name=paymentType]:checked').val() : false;
	var hasChecked = false; 

	// var jqPaymentType = $("select[name=paymentType]");
	var jqPaymentType = $('ul.paymentTypes');
	var inputdata = {};
	inputdata.country = ptGetBillingCountry();
	inputdata.useramount = jQuery('#useramount').val();
	inputdata.language = ptCommon.language;

	if ((typeof inputdata.useramount === "undefined")||(parseInt(inputdata.useramount) === 0)||(inputdata.useramount==''))
		inputdata.useramount = 1; // when undefined amount of users, price for single user license is assumed. Leo, 18.12.2015
	
	// do this with result
	var repopulateCallback = function(data) {
		// data contains key & value since FS#18089
		$count = 0;
		jqPaymentType.children("li").remove(); // Remove all <option> child tags.
	    $.each(data, function(key, value) { // Iterates through a collection
			var text = value;
		
			var checked = '';
			$actClass = "";
			
			if(key == currentlySelected && ptShopRepopulatePaymentTypeOptionsFirstCall == false) { 
				checked = ' checked ';
				$actClass = " act";
				hasChecked = true;
				// license checkbox doesnt need to be unchecked
				uncheckLicenseTerms = false;
			}
			$class = "col-12 col-md-6 col-xl-4";

			
			//hide radio button if there is ony one payment type
			/*if($numPamentTypes == 1 ) {
				$class += " hideRadio";
				$actClass = ' act';
			}*/
			
			if($count%2 == 0) $class += ' offset-xl-1';
			// Append an element to the unordered list
			
	    	jqPaymentType.append( 
			   $('<li class="'+$class+'"></li>')
					.append('<div class="radioContainer'+$actClass+'"><label class="h4 '+key+'" for="option_'+key+'">'+text+'</label><input class="paymentType"'+checked+' id="option_'+key+'" type="radio" name="paymentType" value="'+key+'"><span class="radioBox"></span></div>')
	        );
	    $count++;
		});
		
		if(currentlySelected === false || hasChecked === false) {
			if(ptShop.selectedPaymentType && $('ul.paymentTypes input[value="'+ptShop.selectedPaymentType+'"]').length){
				$('ul.paymentTypes input[value="'+ptShop.selectedPaymentType+'"]').first().attr('checked','checked');
				$('ul.paymentTypes input[value="'+ptShop.selectedPaymentType+'"]').first().parent().addClass('act');
			}
			else {
			jQuery('input[name=paymentType]').first().attr('checked','checked');
				jQuery('input[name=paymentType]').first().parent().addClass('act');
		}
		}

	    // select first value, which is the most likely type for this country
	    //jqPaymentType.val(jqPaymentTypeBefore);
    //$.uniform.update(jqPaymentType); // tell uniform to show the last action
	    if (jqPaymentType.hasClass('errorfield') || jqPaymentType.parent().hasClass('errorfield'))
	    	jqPaymentType.valid(); // tell validator to revalidate
	    
	    // the payment type changed: show it
		ptShopPaymentTypeChanged();

		initPaymentTypes();
		
		ptShopRepopulatePaymentTypeOptionsFirstCall = false;
	}
	
	// if country is not available yet, use default
	if (!inputdata.country){
		repopulateCallback(ptShop.paymenttypes);
	} else {
		$.getJSON("/shop/payment-getsupported", inputdata, repopulateCallback);
	}
	
}

function initPaymentTypes() {
	$('.paymentTypes li .radioContainer').on('click', function(){
		
		if($(this).find('input:radio').attr('disabled') != 'disabled') {
		
			$('.paymentTypes li .radioContainer').removeClass('act');
			$(this).addClass('act');
			
			$('input[name=paymentType]').removeAttr('checked');
			
			$thisValue = $(this).find('input:radio').attr('id').replace('option_', '');
			$('input#option_'+$thisValue).prop('checked',true);
			
			$('.priceCompositionDetails .paymentMethod').hide();
			$('.priceCompositionDetails .paymentMethod.'+$thisValue).show();
			ptShopPaymentTypeChanged();
		}

	});
	
}

/**
 * The paymenttype was changed. Toggle changed acceptance text.
 */
function ptShopPaymentTypeChanged() {
	var curPaymentType = jQuery('input[name=paymentType]:checked').val();
	$('.priceCompositionDetails .paymentMethod').hide();
	$('.priceCompositionDetails .paymentMethod.'+curPaymentType).show();
	
	switch (curPaymentType) {
		case 'SEPA-DD':
			jQuery('.mandate-ccard').hide();
			jQuery('.mandate-sepa-dd').show();
			break;
		case 'CCARD': 
			jQuery('.mandate-sepa-dd').hide();
			jQuery('.mandate-ccard').show();
			break;
		case 'IMP-INV': 
		default:
			jQuery('.mandate-sepa-dd').hide();
			jQuery('.mandate-ccard').hide();
			break;
	}
	// payment types have changed and there is no preselection of the payment type
	// so we have to uncheck the license terms 
	if(uncheckLicenseTerms && !ptShopRepopulatePaymentTypeOptionsFirstCall) {
		$('input[name="terms_accepted"]').prop('checked', false);
	}
}

/**
 * Bind GUI
 */
var ptShop_formValidator;

$(document).ready(function() {
	// Order Form: init datepicker
	var dp = $('#validfromdisplay');
	var validfroms = $('#validfrom').val();
	var dateparts = validfroms.split('-');
	var validfrom = new Date(dateparts[0], dateparts[1]-1, dateparts[2]);
	// TODO:i18n check the formats (source was wikipedia)
	var dateformat = pLang('de','d.m.yy', 'en', 'm/d/yy', 'fr', 'd.m.yy', 'es','dd/mm/yy', 'pt', 'dd/mm/yy', 'it','dd/mm/yy');
	dp = dp.datepicker({
		altFormat: "yy-mm-dd",
		altField: '#validfrom',
		dateFormat: dateformat,
		minDate: 0,
		onClose: function() {
			//make sure the datepicker is validated on date select
			dp.valid();
    }
	});
	$('#ptdateformat').val(dateformat);
	
	// set date
	dp.datepicker("setDate", validfrom);
	
	$('input[name=integration]').on('change', changedIntegration);
	
	//FS#20566 user amount has now inpact if vatnrnotapplicable checkbox is shown or not
	$('#useramount').on('change', function(){
		ptCheckToggleVatnrnotapplicable();
	});
	
	// Order Form: Separate Billing Address
	$('input[name=separatebillingaddress]').on('change', function(e) {
		try {
			if ($('input[name=separatebillingaddress]').prop("checked")) {
				$('#separatebillingaddressdiv').fadeIn();
				// fields.rules("add", { required:true }); // the rules() method has a bug: it works only on the first found jquery element. hmnjah. This doesnt work
				$('input[name=address2_name]').rules("add", { required:true }); 
				$('input[name=address2_line1]').rules("add", { required:true }); 
				$('input[name=address2_postalcode]').rules("add", { required:true }); 
				$('input[name=address2_city]').rules("add", { required:true });
				$('select[name=address2_country]').rules("add", { required:true });
				$('input[name=emailaddress2]').rules("add", { 
					required:true, 
					email: false,
					remote: {
						url: '/apply/verifyEmail',
						timeout: 9500,
						data : {
							language: ptCommon.language
						},
						error: function(jqXHR, textStatus, errorThrown) {
							$('input[name=emailaddress2]').rules('remove','remote');
							if (ptShop_formValidator != null) {
								ptShop_formValidator.pendingRequest--;
								ptShop_formValidator.element('input[name=emailaddress2]');
							}
							console.log('AJAX verification error: ' + textStatus);
						},
						beforeSend: function(jqXHR, settings) {
							
							$('input[name=emailaddress2]').addClass('verifyanim');	
							$("button[name=shopsbmt]").addClass('button-disabled');
							
						},
						complete: function(jqXHR, textStatus) {
							$('input[name=emailaddress2]').removeClass('verifyanim');
							$("button[name=shopsbmt]").removeClass('button-disabled');
						}
					}
				});
			} else {
				$('#separatebillingaddressdiv').fadeOut();
				// remove required validation
				// fields.rules("remove"); // the rules() method has a bug: it works only on the first found jquery element. hmnjah. This doesnt work
				$('input[name=address2_name]').rules("remove"); 
				$('input[name=address2_line1]').rules("remove");
				$('input[name=address2_postalcode]').rules("remove");
				$('input[name=address2_city]').rules("remove");
				$('select[name=address2_country]').rules("remove");
				$('input[name=emailaddress2]').rules("remove");
	
				// and clear out the fields
				var fields = $('#separatebillingaddressdiv input, #separatebillingaddressdiv select');
				fields.val('');
				//$.uniform.update(fields); // tell uniform to show the last change
			}
		} catch (e) {
			console.log("error showing separate billing address: " + e);
			ptClientErrorLog({caller: 'ptshop.js:separatebillingaddress-changeevent', errorThrown: e });
		}
		ptShopCountryChanged_CheckVatRequirements();	
	});
	
	// Order Form: show/hide state depending on country. The country is already set.
	showStateForCountry(jQuery('input[name=address1_stateorprovince]').parent(), jQuery('select[name=address1_country]'));
	showStateForCountry(jQuery('input[name=address2_stateorprovince]').parent(), jQuery('select[name=address2_country]'));
	
	// Listen to changes affecting if VAT NR is required  
	jQuery('select[name=address1_country], select[name=address2_country]').on('change', ptShopCountryChanged_CheckVatRequirements);

	// Listen to changes that affect core Shop parameters
	jQuery('select[name=address1_country], select[name=address2_country], input[name=separatebillingaddress]')
		.on('change', ptShopCountryChanged_CheckUpdateShopParameters);
	
	// Listen to changes requiring a re-validation of VAT NR 
	// NOT COUNTRY, that is already covered in ptShopCountryChanged_CheckVatRequirements 
	jQuery('input[name=address2_name],input[name=companyname],input[name=address2_line1],input[name=address1_line1],input[name=address2_postalcode],input[name=address1_postalcode],input[name=address2_stateorprovince],input[name=address1_stateorprovince],input[name=address2_city],input[name=address1_city]')				
		.on('change', ptRevalidateVat);
	
	// Listen to the VAT nr change 
	jQuery('input[name=vatnr]')				
		.on('change', ptVatNrChanged)
		// only show VAT errors after the user has been in the field once (or when the whole form is submitted, but this is elsewhere)
		.on('focus', function () {
			// once the vatnr has focus, errors of it can be shown. Arm the check. 
			jQuery('input[name=vatnr]').data('hasbeeninfocus', true);
		});
	
	// Listen to the vatnrnotapplicable check being checked
	jQuery('input[name=vatnrnotapplicable]')		
		.on('change', function() {
			if (jQuery( this ).is(":checked")) {
				if (jQuery('input[name=vatnr]').val()) {					
					jQuery('input[name=vatnr]').val('');
					ptVatNrChanged();
				}
			} 
			ptRevalidateVat(true);
			ptCheckVatnrnotapplicableVatmsg();
		});
	// initialize the visibility of #vatnrnotapplicable-vatmsg
	ptCheckVatnrnotapplicableVatmsg();
		
	// Listen to changes affecting Payment Type 
	jQuery('select[name=address1_country], select[name=address2_country], input[name=separatebillingaddress], #useramount')
		.on('change', ptShopRepopulatePaymentTypeOptions);
	// initial run for payment type options
	ptShopRepopulatePaymentTypeOptions();
	
	// Listen to changes of payment type
	jQuery('ul.paymentTypes').on('click','input', function(e){
		uncheckLicenseTerms = true;
		ptShopPaymentTypeChanged(e);
	});
	
	/**
	 * FS#13701: validation for brazilian phone numbers
	 */
	jQuery.validator.addMethod('brPhone', 
		function(value) { 
			return (value.replace(/[^0-9]/g,"").length > 9); 
		},pLang__('brPhoneErrorMessage')
	);
	
	/**
	 * Requires Datepicker.
	 * Params: 
	 * 0...dateformat. see datepicker
	 * 1...date. Value "0" is "today"
	 * 2...(optional). date to display. will be automatically filled if 0 and 1 are set.
	 * usage:
	 * myfield: { minDate: ['m/d/yy', 0] }
	 */
	jQuery.validator.addMethod("minDate", 
		function(value, element, params) {
			if (!params[0])
				throw 'params missing dateFormat';
			if (typeof(params[1]) == 'undefined' )
				throw 'params missing minDate';
			
			var dateFormat = params[0];
			var minDate = params[1];
			if (minDate == 0) {
				minDate = new Date();
				minDate.setHours(0); // make it 00:00:0
				minDate.setMinutes(0);
				minDate.setSeconds(0);
				minDate.setMilliseconds(0);
			}
			if (typeof(params[2]) == 'undefined' )
				params[2] = $.datepicker.formatDate(dateFormat, minDate);
			
			try {
				var valueAsDate = $.datepicker.parseDate( dateFormat, value )
				return (valueAsDate >= minDate);
			} catch (x) {
				return false;
			}

		},pLang__('shopmindatevalidate'));
	

	
	// Note: the (optional) billing address is set to required dynamically above using rules()
	// on another note: if its brazil the telephonnumber gets checked
	var rules = ptOrderFormData.form_validation_rules;
	
	
	rules.telephone1.brPhone = {
		depends: function(element) {
			return $('select[name=address1_country]').val() == "BR";
		},
	};
	
	rules.emailaddress1.remote = {
					url: '/apply/verifyEmail',
					timeout: 9500,
					data : {
						language: ptCommon.language
					},
					error: function(jqXHR, textStatus, errorThrown) {
						$('input[name=emailaddress1]').rules('remove','remote');
						if (ptShop_formValidator != null) {
							ptShop_formValidator.pendingRequest--;
							ptShop_formValidator.element('input[name=emailaddress1]');
						}
						console.log('AJAX verification error: ' + textStatus);
					},
					beforeSend: function(jqXHR, settings) {
						$('input[name=emailaddress1]').addClass('verifyanim');	
						$("button[name=shopsbmt]").addClass('button-disabled');
						
					},
					complete: function(jqXHR, textStatus) {
						$('input[name=emailaddress1]').removeClass('verifyanim');
						$("button[name=shopsbmt]").removeClass('button-disabled');
					}
				};

	rules.validfromdisplay.minDate = [dateformat, 0];
	rules.vatnr = {
				required : {
					depends: function(element) {
						return input_vatnr.data("vatnr-isRequired") 
							&& ! (input_vatnr.data("vatnr-notApplicableAllowed") && jQuery('input[name=vatnrnotapplicable]').is(":checked"));
					},
				},
				remoteVATCheck: {
					param: { 
						url: '/shop/CheckVatNrAjax',
						timeout: 10000,
						data : {
							language: ptCommon.language,
							country : function () {
								return ptShop_sepbill ?
									jQuery('select[name=address2_country]').val()
									: jQuery('select[name=address1_country]').val();
								},
							companyname : function () {
								return ptShop_sepbill ?
									jQuery('input[name=address2_name]').val()
									: jQuery('input[name=companyname]').val();
								},	
							street : function () {
								return ptShop_sepbill ?
									jQuery('input[name=address2_line1]').val()
									: jQuery('input[name=address1_line1]').val();
								},
							postalcode : function () {
								return ptShop_sepbill ?
									jQuery('input[name=address2_postalcode]').val()
									: jQuery('input[name=address1_postalcode]').val();
							},
							stateorprovince : function () {
								return ptShop_sepbill ?
										jQuery('input[name=address2_stateorprovince]').val()
										: jQuery('input[name=address1_stateorprovince]').val();
							},
							city : function () {
								return ptShop_sepbill ?
										jQuery('input[name=address2_city]').val()
										: jQuery('input[name=address1_city]').val();
							}
						},
						// Error handling in the remoteVATCheck implementation above
//						error: function(jqXHR, textStatus, errorThrown) {
//
//						},
						beforeSend: function(jqXHR, settings) {
							input_vatnr.addClass('verifyanim');	
							$("button[name=shopsbmt]").addClass('button-disabled');
						},
						complete: function(jqXHR, textStatus) {
							input_vatnr.removeClass('verifyanim');
							$("button[name=shopsbmt]").removeClass('button-disabled');
						},
						
					},
					depends: function(element) {
						return input_vatnr.data("vatnr-isRequired")
							&& input_vatnr.data("vatnr-ajaxCheck")
							&& ! (input_vatnr.data("vatnr-notApplicableAllowed") && jQuery('input[name=vatnrnotapplicable]').is(":checked"));
					},
				}
			};
	
	
	var input_vatnr = $('input[name=vatnr]'); 
	ptShop_formValidator = $("#orderform").validate({
			// ignore: ... do include "disabled" if setting "ignore". VAT field is disabled if "vatnrnotapplicable"
			errorClass: "errorfield",
			validClass: "validfield",
			focusInvalid: false,
	    invalidHandler: function(form, validator) {

	        if (!validator.numberOfInvalids())
	            return;
	        
	        $('html, body').animate({
	            scrollTop: $(validator.errorList[0].element).parent().offset().top-$('.header-container').height()-20
	        }, 1000);

	    },
			onkeyup : false,
			onsubmit: true,
			onfocusout : function(element, event) {
				var val = $(element).val(); val = val.trim();$(element).val(val); $(element).valid(); 
			},
			errorElement : 'span',
			errorPlacement: function(error, element) { 
					error.insertAfter(element);
						},
			showErrors: function(errorMap, errorList) {
				this.defaultShowErrors();
				// it has put the message inside the span. I want it inside the title of the span
				try {
					for ( i = 0; errorList[i]; i++ ) {
						var error = this.errorList[i];
						var label = this.errorsFor( error.element );
						label.text(error.message);
					}
				} catch (e) {
					console.log(e);
					if (e.stack !== undefined)
						console.log(e.stack);
				}
			},
			highlight: function(element, errorClass, validClass) {
				element = $(element);
				if (element.parent().hasClass('selector'))// unify inserts weird stuff, avoid id
					element = element.parent();
				element.addClass(errorClass).removeClass(validClass);
				element.closest('.input-box').addClass(errorClass);
				element.prev().addClass('errorlabel'); // the label left of the input
				if (element.attr('name') == 'vatnr')
					ptCheckToggleVatnrnotapplicable(true);
			  },
			unhighlight: function(element, errorClass, validClass) {
				element = $(element);
				if (element.parent().hasClass('selector'))// unify inserts weird stuff, avoid id
					element = element.parent();
				element.removeClass(errorClass).addClass(validClass);
				element.closest('.input-box').removeClass(errorClass);
				element.prev().removeClass('errorlabel'); // the label left of the input
			  },
			rules: rules
	});
	
	changedIntegration();
	
	ptShopCountryChanged_CheckVatRequirements();	// this modifies the validator that was initialized above by validate().

	// update "order-now" subline based on pricing
	jQuery(document).on('ptPriceCalculatorUpdated',  ptShop_PriceCalcUpdated_ShowAmount );
	ptShop_PriceCalcUpdated_ShowAmount();
	
	$('.supportWidgetButton').on('click', function(){
			pSendGAEvent('pt_shop_supportbutton_click', { }, 'ptshop.js', 'supportWidgetButton send event gone wrong');
	});
	
	$(window).on('scroll', function() {
		
		if(($('#pricing').height() - $('.priceOverviewContainer').offset().top + $('.priceOverviewContainer').outerHeight()) < 15) {
			$('.supportWidgetButton').addClass('scrolling');
		} else {
			$('.supportWidgetButton').removeClass('scrolling');
		}
				
	});
	
});